import React from 'react';
import './RegistrationPage.css';

const fees = [
  { type: 'Standard', price: 'AUD $1500' },
  { type: 'Early bird', price: 'AUD $1350' },
  { type: 'Student', price: 'AUD $1000' },
  { type: 'Day registration', price: 'AUD $600' },
];

const RegistrationPage = () => {
  return (
    <section className="registration-page fade-in-up">
      <div className="registration-wrapper">
        <span className="badge registration-badge">Pricing</span>
        <h1 className="registration-heading">Registration Fee</h1>
        <ul className="registration-notes">
          <li>A single registration for a participant only permits one academic presentation during the conference.</li>
          <li>If the full paper exceeds 8 pages, there will be an additional $45 registration fee per page.</li>
        </ul>

        <p className="registration-portal-note">To receive your conference ticket, you must register an account in the Submission Portal. After creating your account (or logging in), open the <strong>Conference Registration</strong> section to get your unique payment reference, then pay on the UQ page using that reference and your account email. Your QR ticket appears in the portal once payment is confirmed.</p>

        <table className="registration-table">
          <tbody>
            {fees.map((fee) => (
              <tr key={fee.type}>
                <td className="fee-type">{fee.type}</td>
                <td className="fee-price">{fee.price}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <h2 className="registration-heading" style={{ fontSize: '1.4rem', marginTop: '2rem' }}>Your Ticket</h2>
        <ul className="registration-notes">
          <li>After your payment is confirmed, your <strong>QR ticket</strong> appears in the Submission Portal. Each ticket has its own QR code and ticket ID (<strong>TIC-…</strong>), and you may have more than one depending on what you purchased.</li>
          <li>Your <strong>conference ticket</strong> is scanned once at the registration desk when you collect your delegate package and name badge.</li>
          <li>If your registration includes the <strong>banquet</strong> — or you add an extra banquet ticket — that ticket is scanned once at the banquet entrance for your wristband. Extra banquet tickets can be forwarded to a guest.</li>
          <li>Download all your tickets as a PDF from the portal, or keep a screenshot of each QR on your phone.</li>
        </ul>

        <a href="https://ices2026-portal.com" target="_blank" rel="noreferrer" id="register-button2">Register / Buy Ticket in the Portal</a>
      </div>
    </section>
  );
};

export default RegistrationPage;
